import { axiosWdw, domainEndpoint } from './axios';
import { IBmsDomain } from '@/models/domain.model';
import { FormControlOptions } from '@/models/form-control.model';
import { IAttribute } from '@/models/attribute.model';
export default {
  searchAddress(searchText: string) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/search_address',
        params: { q: searchText, lang: 'de' },
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getRegistrationConfig() {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/register_config',
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  postRegister(regData: any) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + '/register',
        data: regData,
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getDomainConfig() {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint(),
      params: { fieldset: 'config' },
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  getDiscussConfig() {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + '/discuss',
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  getBmsDomainConfig(): Promise<IBmsDomain> {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/bms',
        params: { fieldset: 'config' },
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getBmsStatusList(): Promise<FormControlOptions[]> {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/bms/status_list',
      })
        .then(response => {
          resolve(response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getStreets(domainid: number): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/get_streets?domainid=' + domainid,
      })
        .then(response => {
          resolve(response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getBmsAppDomainByQueryParams(bmsAppId: number, params?: { lat: number; lon: number }): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: 'bmsapp/' + bmsAppId + '/domain',
        params: params,
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          }
          reject(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getBmsSearchAttributes(): Promise<IAttribute[]> {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/bms/search_attributes',
      })
        .then(response => {
          resolve(response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updateMessageState(params: any): Promise<IBmsDomain> {
    const formdata = new FormData();
    formdata.append('data', JSON.stringify(params.body));
    if (params.file) {
      formdata.append('picture', params.file);
    }
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + '/update',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formdata,
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          }
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  postRefetchCaptcha() {
    return axiosWdw({
      method: 'POST',
      url: domainEndpoint() + '/refetch_captcha',
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  validateCaptcha(captchaId: number, userInput: string): Promise<{ valid: boolean }> {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + '/verify_captcha',
        data: {
          id: captchaId,
          answer: userInput,
        },
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};
